import * as React from "react"
import { useEffect, useLayoutEffect } from "react"
import { ButtonLink, EmptyState, EmptyStateTitle, Text } from "@indeed/ifl-components"
import { ArrowRight } from "@indeed/ifl-icons"
import { Error4 } from "@indeed/indeed-design-system-illustrations-spot"
import { configSelector } from "../../../common/utils/config-slice"
import { useI18n } from "../../../common/utils/i18n-context"
import { useAppSelector } from "../../../common/utils/redux-helpers"
import { displayFooter } from "../../../common/utils/utils"

export const ExplicitFeedbackLimitPage: React.FC = () => {
    const config = useAppSelector(configSelector)
    const { gettext } = useI18n()

    useLayoutEffect(() => {
        displayFooter()
    }, [])

    useEffect(() => {
        document.title = gettext("Limit reached")
        document.getElementById("explicit-feedback-limit-header")?.focus()
    }, [])

    const preferencesPath = "/preferences#not-interested"
    const preferencesLink = `${config.profileUrl}${preferencesPath}`

    return (
        <EmptyState
            illustration={<Error4 size="sm" />}
            actions={[
                <ButtonLink href={config.jobSearchUrl} variant="secondary" key="secondary" iconAfter={<ArrowRight />}>
                    {gettext("Find jobs")}
                </ButtonLink>,
                <ButtonLink key="primary" iconAfter={<ArrowRight />} href={preferencesLink}>
                    {gettext("Manage preferences")}
                </ButtonLink>,
            ]}
            sx={{
                marginBlockEnd: 0,
                marginBlockStart: 0,
                marginInlineEnd: "auto",
                marginInlineStart: "auto",
                maxInlineSize: "35.625rem",
                paddingBlockEnd: 2,
                paddingBlockStart: "2.72rem",
                paddingInlineEnd: 2,
                paddingInlineStart: 2,
                svg: {
                    maxInlineSize: "4.93rem !important",
                },
            }}
            id="explicit-feedback-limit-page-main"
        >
            <EmptyStateTitle
                as="h1"
                sx={{
                    marginBlockStart: 3,
                    marginBlockEnd: 3,
                    ":focus-visible": { outline: "none" },
                }}
                // @ts-ignore
                id="explicit-feedback-limit-header"
                tabIndex={-1}
            >
                {gettext('"Not interested" limit reached')}
            </EmptyStateTitle>
            <Text level={2} sx={{ marginBlockEnd: 5 }}>
                {gettext('To hide more job details, remove "Not interested" details in your profile.')}
            </Text>
        </EmptyState>
    )
}
